var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ad-page"},[_vm._t("nav-bar",[_c('van-nav-bar',{attrs:{"title":_vm.title,"left-arrow":""},on:{"click-left":_vm.onClickLeft}})]),_c('div',{staticClass:"ad-page-main"},[_vm._t("default")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }